/**
 * The approval inbox's order: soonest affected date first, with each person's
 * requests kept together. A person sits where their earliest request falls,
 * and their own requests follow in date order, so nobody else's request comes
 * between them.
 */
export function bundleByPerson<T extends { employeeId: string; sortDate: string }>(items: T[]): T[] {
  const sorted = [...items].sort((a, b) => a.sortDate.localeCompare(b.sortDate))
  const groups = new Map<string, T[]>()
  for (const item of sorted) {
    const group = groups.get(item.employeeId)
    if (group) group.push(item)
    else groups.set(item.employeeId, [item])
  }
  return Array.from(groups.values()).flat()
}
